'use client';

import { useEffect } from 'react';

import { store } from '@/redux-store';
import { useAppSelector } from '@/redux-store/hooks';
import { bootstrapAuthThunk } from '@/redux-store/slices/auth';

export default function AuthBootstrapper() {
    const status = useAppSelector(s => s.auth.status);

    useEffect(() => {
        if (status === 'idle') {
            store.dispatch(bootstrapAuthThunk());
        }
    }, [status]);

    return null;
}
